import axios from 'axios'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, type Messaging, onMessage } from 'firebase/messaging'
import { toast } from 'vue-sonner'
import { useApi } from '@/functions/api'
import { canShowNotification } from '@/functions/notification'
import { useAuthStore } from '@/stores/auth'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

export const app = initializeApp(firebaseConfig)

let messaging: Messaging | null = null

try {
  messaging = getMessaging(app)

  if (typeof window !== 'undefined') {

    const win = window as any
    if (!win.__firebaseMessagingInitialized) {
      win.__firebaseMessagingInitialized = true

      // Request permission and get token
      getToken(messaging).then((currentToken) => {
        if (currentToken) {
          // Send token to backend
          const api = useApi()

          api.POST('/dashboard/device-token', { device_token: currentToken })

          const authStore = useAuthStore()
          authStore.setDeviceToken(currentToken)
        } else {
          console.log('No registration token available. Request permission to generate one.')
        }
      }).catch((err: unknown) => {
        console.log('An error occurred while retrieving token. ', err)
      })

      onMessage(messaging, (payload) => {
        const authStore = useAuthStore()

        // Construct mock Notification object
        const mockNotification = {
          id: payload.data?.id || '',
          type: payload.data?.type || '',
          data: {
            class: payload.data?.class || '',
            message: payload.notification?.body || payload.data?.message || '',
            model_id: payload.data?.model_id ? Number(payload.data.model_id) : undefined,
          },
          read_at: null,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        } as unknown as Notification

        if (!canShowNotification(mockNotification, authStore)) {
          return
        }

        // Show toast
        toast.info(payload.notification?.title || 'New Notification', {
          description: payload.notification?.body,
        })

        // Increment notification count
        authStore.setNotificationCount(authStore.notificationCount + 1)
      })
    }
  }
} catch (error) {
  console.warn('Firebase Messaging failed to initialize:', error)
}

export { messaging }
